import React from 'react';
import TeamMemberAboutContainer from '../editMember/about/TeamMemberAboutContainer';
import TeamContactLinksContainer from '../editMember/links/TeamContactLinksContainer';
import TeamLeadCaptureContainer from '../editMember/leadCapture/TeamLeadCaptureContainer';
import TeamFollowUpEmailContainer from '../editMember/followUpEmail/TeamFollowUpEmailContainer';
import TeamQRCodeContainer from '../editMember/qrCode/TeamQRCodeContainer';
import TeamTemplateQRCodeContainer from './sections/TeamTemplateQRCodeContainer';
import TeamTemplateSettingsContainer from './sections/TeamTemplateSettingsContainer';
import TeamTemplateAboutContainer from './sections/TeamTemplateAboutContainer';

const TeamTemplateEditContent = ({ selectedItem, template, onTemplateUpdate, isCreating, onSave, onCancel, isSubmitting, user, setSelectedItem }) => {
    return (
        <>
            {/* Always render About but conditionally show/hide */}
            <div style={{ display: selectedItem === 'about' ? 'block' : 'none' }}>
                <TeamTemplateAboutContainer
                    template={template}
                    onTemplateUpdate={onTemplateUpdate}
                    isCreating={isCreating}
                    onSave={onSave}
                    onCancel={onCancel}
                    isSubmitting={isSubmitting}
                />
            </div>

            {/* Render other components conditionally */}
            {selectedItem === 'links' && <TeamContactLinksContainer user={user} />}
            {selectedItem === 'qrCode' && (
                <TeamTemplateQRCodeContainer
                    template={template}
                    onTemplateUpdate={onTemplateUpdate}
                    isCreating={isCreating}
                    onSave={onSave}
                    onCancel={onCancel}
                    isSubmitting={isSubmitting}
                />
            )}
            {selectedItem === 'leadCaptureForm' && <TeamLeadCaptureContainer />}
            {selectedItem === 'followUpEmail' && <TeamFollowUpEmailContainer />}

            {selectedItem === 'settings' && (
                <TeamTemplateSettingsContainer
                    template={template}
                    onTemplateUpdate={onTemplateUpdate}
                    isCreating={isCreating}
                    onSave={onSave}
                    onCancel={onCancel}
                    isSubmitting={isSubmitting}
                />
            )}
        </>
    );
};

export default TeamTemplateEditContent;

